import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from "../hooks/useAuth";
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, sessionExpired } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  try {
    const res = await fetch(
      process.env.REACT_APP_API_URL + "/api/auth/login",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          password
        })
      }
    );

    // Verificar si la respuesta es JSON
    const contentType = res.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new Error("Error del servidor. Por favor, contacte al administrador.");
    }

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "Error al iniciar sesión");
    }

    // guardar token y usuario usando el método login del contexto
    login(data.user, data.token);

    navigate("/");

  } catch (err) {
    console.error("Error de login:", err);
    setError(err.message || "Error de conexión con el servidor");
  }

  setLoading(false);
};

  return (
    <div className="login-page">

      {/* ── Panel izquierdo: branding + features ── */}
      <div className="login-left">
        <img
          src="/logo-menu-sidebar-ai-leth-blanco.png"
          alt="Ai-leth"
          className="login-left-logo"
          onError={(e) => { e.target.onerror = null; e.target.src = "/logo-aileth-nuevo.png"; }}
        />
        <h1 className="login-left-title">CRM · Contabilidad · IA</h1>
        <p className="login-left-sub">
          Gestiona tu empresa desde una sola plataforma, contacta, vende y factura.
        </p>
        <div className="login-features">
          {[
            { icon: "🧾", title: "Facturación Electrónica", desc: "Emite facturas autorizadas en segundos" },
            { icon: "📊", title: "Contabilidad Automática", desc: "Asientos, balance y reportes al instante" },
            { icon: "🤖", title: "Asistente IA integrado", desc: "Responde clientes con IA 24/7" },
            { icon: "💬", title: "CRM con chat en vivo", desc: "Pipeline, leads y bandeja de mensajes" },
          ].map((f) => (
            <div key={f.title} className="login-feature-item">
              <div className="login-feature-icon">{f.icon}</div>
              <div className="login-feature-text">
                <strong>{f.title}</strong>
                <span>{f.desc}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Panel derecho: formulario ── */}
      <div className="login-right">
        <div className="login-form-header">
          <h2>Bienvenido de nuevo</h2>
          <p>Ingresa tus credenciales para continuar</p>
        </div>

        {sessionExpired && (
          <div className="login-session-warn login-form" style={{ maxWidth: 360 }}>
            ⚠️ Tu sesión expiró. Por favor inicia sesión nuevamente.
          </div>
        )}

        {error && (
          <div className="login-error login-form" style={{ maxWidth: 360 }}>
            {error}
          </div>
        )}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label htmlFor="login-email">Correo electrónico</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ejemplo@correo.com"
              autoComplete="email"
              required
            />
          </div>

          <div className="login-field">
            <label htmlFor="login-pass">Contraseña</label>
            <input
              id="login-pass"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </div>

          <div className="login-extras">
            <label>
              <input type="checkbox" /> Recordarme
            </label>
          </div>

          <button className="login-btn" disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión →'}
          </button>
        </form>

        <p className="login-footer-brand">
          Powered by <a href="https://betelmarket.com" target="_blank" rel="noopener noreferrer">Betelmarket</a>
        </p>
      </div>

    </div>
  );
}
